export const createRatingsFrag = `
    id
`;

export const updateRatingsFrag = `
    id
`;
